module.exports = __webpack_public_path__ + "static/media/facebook.94ff1c4b.svg";